module.exports = __webpack_public_path__ + "static/media/javascript.33eae4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/javascript.png
// module id = 100
// module chunks = 0